import { styled } from "../../../styles";

/**
 * Styles for the /admin Patients group — Treatments (EN-5156), 1MSTS
 * (EN-5159) and Measurements (EN-5158). Generic admin chrome lives in
 * `shared/AdminPage.styles.ts`; only pieces specific to these pages belong
 * here.
 */

/** Per-row text button in a table's action column. */
/**
 * Count cell that draws attention to itself only when there is something to
 * see — Retool showed a plain number and an operator scanning for trouble had
 * to read every row.
 */
export const CountCell = styled("span", {
  fontFamily: "$openSans",
  fontVariantNumeric: "tabular-nums",

  variants: {
    tone: {
      neutral: {
        color: "$charcoal",
      },
      warning: {
        color: "$error-dark",
        fontWeight: "600",
      },
    },
  },

  defaultVariants: {
    tone: "neutral",
  },
});

/** Label/value rows in the archive confirmation. */
export const ValueList = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  padding: "12px",
  borderRadius: "6px",
  backgroundColor: "$gray-20",
});

export const ValueRow = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
  gap: "16px",
});

/** Chip list of the measurement types a row carries. */
export const TypeTags = styled("span", {
  display: "inline-flex",
  flexWrap: "wrap",
  gap: "4px",
});

export const TypeTag = styled("span", {
  padding: "2px 6px",
  borderRadius: "4px",
  backgroundColor: "$gray-20",
  color: "$gray-80",
  fontSize: "11px",
  fontFamily: "$openSans",
  whiteSpace: "nowrap",
});

/** Holds two row actions side by side without wrapping. */
export const RowActions = styled("div", {
  display: "flex",
  gap: "6px",
  justifyContent: "flex-end",
});

/** Hospital and ward pickers: wide enough for a full hospital name. */
export const FilterField = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  width: "320px",
  maxWidth: "100%",
});
